import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class HRPartyMember  {
    _originalTypeClassName = "zERP.BO.HRPartyMember";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
HRPartyMember.translate = translateService;
}
this.Employee = new Domain.Employee();
this.DeactivationReasonFiles = [];
this.Id = null;
this.IsRegular = false;
this.IsSubstitute = false;
this.Comments = null;
this.IsActive = false;
this.ExtraPayAmount = null;
this.DeactivationnReasonText = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsRegular:any;
IsSubstitute:any;
Comments:any;
IsActive:any;
ExtraPayAmount:any;
DeactivationnReasonText:any;
Employee:any;
Party:any;
DeactivationReasonFiles:any;
Role:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setParty = ($this, value) => {
var oldValue = $this.Party;
$this.Party = value;
if (value != null) {
if (oldValue != null) {
Domain.HRParty.removeMembers(oldValue, $this);
}
Domain.HRParty.addMembers(value, $this);
}
}
static setDeactivationReasonFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.DeactivationReasonFiles == null) $this.DeactivationReasonFiles = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DeactivationReasonFiles.length > 0) {
                    Domain.HRPartyMember.removeDeactivationReasonFiles($this, $this.DeactivationReasonFiles[0]);
                }

                Domain.HRPartyMember.addManyDeactivationReasonFiles($this, copyItems);
            }
static addManyDeactivationReasonFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.HRPartyMember.addDeactivationReasonFiles($this, items[i]);
                }
            }
static addDeactivationReasonFiles = ($this, item) => {
                if ($this.DeactivationReasonFiles == null) $this.DeactivationReasonFiles = [];
                if (item == null || $this.DeactivationReasonFiles.indexOf(item) > -1) return;
                $this.DeactivationReasonFiles.push(item);
}
static addRangeDeactivationReasonFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.HRPartyMember.addDeactivationReasonFiles($this, item));
            }
static removeDeactivationReasonFiles = ($this, item) => {
                if ($this == null || $this.DeactivationReasonFiles == null || $this.DeactivationReasonFiles.indexOf(item) === -1) return;
                var _index = $this.DeactivationReasonFiles.indexOf(item);
                $this.DeactivationReasonFiles.splice(_index, 1);
}
static clearDeactivationReasonFiles = ($this) => { $this.DeactivationReasonFiles = null; }
static setRole = ($this, value) => {
var oldValue = $this.Role;
$this.Role = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}